export enum SortSource {
    OPEN_NOMINATIONS,
    CLOSED_NOMINATIONS
}
